import { Drawing } from "@sportactics/board-editing";

import { DrawingModel } from "./drawing-model";

export function convertDrawingToModel(drawing: Drawing): DrawingModel {
  return {
    id: drawing.id,
    points: [...drawing.points],
    color: drawing.color,
    width: drawing.width,
  };
}
